import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

export interface DateValues {
  dateFrom: string;
  dateTo: string;
}

interface Props {
  maxDate?: string;
  dateFrom?: string;
  dateTo?: string;
  resetOtherFilters?: Function;
  onChange: Function;
}
const dateFormat = "DD.MM.YY";

const DateRangePicker = ({
  maxDate,
  dateFrom,
  dateTo,
  resetOtherFilters,
  onChange,
}: Props) => {
  return (
    <>
      <RangePicker
        format={dateFormat}
        disabledDate={
          maxDate ? (date) => !date || date.isAfter(maxDate, "day") : undefined
        }
        defaultValue={
          dateFrom && dateTo ? [moment(dateFrom), moment(dateTo)] : undefined
        }
        onOpenChange={() => (resetOtherFilters ? resetOtherFilters() : {})}
        onChange={(dates) => {
          // happens if user clears the dateRangePicker
          if (!dates) {
            onChange({
              dateFrom: undefined,
              dateTo: undefined,
            });
          } else {
            onChange({
              dateFrom: dates[0]?.format("YYYY-MM-DD"),
              dateTo: dates[1]?.format("YYYY-MM-DD"),
            });
          }
        }}
      />
    </>
  );
};

export default DateRangePicker;
